import React, { useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectIsLoadingRanks, makeSelectRanks } from "./selectors"
import { getListRanksWatcher } from "./actions"

import "./index.less"
import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../utils/storage"
import AnalysisSegment from "../../../containers/Report/Home/Components/AnalysisSegment"
import { validate } from "../../../utils/functions"
/*
import { Spin } from "antd"
*/

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function WidgetAnalysisSegment(props) {
  const [measureID] = useState(props.idMeasure)
  const [divisionID] = useState(props.idDivisionSelected)
  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = async () => {
    const {
      idMeasure,
      getListRanks,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props
    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    getListRanks(params)
  }

  return (
    <AnalysisSegment
      ranks={props.ranks}
      measure={props.idMeasure}
      isLoading={props.isLoadingRanks}
      ambassadorDivisionSelected={
        validate.exist(props.idDivisionSelected)
          ? props.idDivisionSelected
          : props.idDivisionParent
      }
      idParentDivision={props.idDivisionParent}
      selectedSegment={props.selectedSegment}
    />
  )
}

WidgetAnalysisSegment.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingRanks: PropTypes.bool,
  ranks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoadingRanks: makeSelectIsLoadingRanks(),
  ranks: makeSelectRanks(),
})

function mapDispatchToProps(dispatch) {
  return {
    getListRanks: (params) => dispatch(getListRanksWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetAnalysisSegment", reducer })
const withSaga = injectSaga({ key: "widgetAnalysisSegment", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetAnalysisSegment)
